import { gql } from '@apollo/client';

export const discussionBasicFragmentNew = gql`
  fragment discussionBasicFragmentNew on ListDiscussion {
    id
    title
    description
    status
    textStatus
    textCustomTimeFrameEnabled
    textStartDate
    textEndDate
    timeFrames {
      id
      startDateTime
      endDateTime
    }
    type
  }
`;

export const discussionListFragmentNew = gql`
  ${discussionBasicFragmentNew}
  fragment discussionListFragmentNew on ListDiscussion {
    ...discussionBasicFragmentNew
    hasVisited
    isRecommended
    textParticipants {
      id
      attendeeId
      firstName
      lastName
      title
      company
      profilePicture
      connectionStatus
    }
    textParticipantCount
    videoParticipants {
      id
      attendeeId
      firstName
      lastName
      title
      company
      profilePicture
      connectionStatus
    }
    videoParticipantCount
    participationHistoryCount
    isFeatured
  }
`;

export const DISCUSSION_LIST = gql`
  ${discussionListFragmentNew}
  query GET_DISCUSSION_LIST($locale: String, $limit: Int, $type: [DiscussionType!], $status: [DiscussionStatus!]) {
    getDiscussionList(locale: $locale, limit: $limit, type: $type, status: $status) {
      ... on DiscussionsList {
        discussions {
          ...discussionListFragmentNew
        }
      }
      ... on PermissionDenied {
        permissionType
        errorCode
        details
      }
    }
  }
`;

export const discussionDetailsBasicFragmentNew = gql`
  fragment discussionDetailsBasicFragmentNew on DiscussionDetail {
    id
    title
    description
    status
    textStatus
    textCustomTimeFrameEnabled
    textStartDate
    textEndDate
    timeFrames {
      id
      startDateTime
      endDateTime
    }
    type
  }
`;

export const participantFragment = gql`
  fragment participantFragment on Participant {
    id
    attendeeId
    firstName
    lastName
    title
    company
    profilePicture
  }
`;

export const roomFragment = gql`
  ${participantFragment}
  fragment roomFragment on Room {
    id
    startDate
    active
    updatedAt
    participants {
      ...participantFragment
    }
  }
`;

export const discussionDetailsFragmentNew = gql`
  ${discussionDetailsBasicFragmentNew}
  fragment discussionDetailsFragmentNew on DiscussionDetail {
    ...discussionDetailsBasicFragmentNew
    chatSettings {
      isEnabled
      stream {
        channelId
        channelType
        isAvailable
      }
      timeRange {
        startDate
        endDate
      }
    }
    isFeatured
  }
`;

export const DISCUSSION_DETAIL = gql`
  ${discussionDetailsFragmentNew}
  query DISCUSSION_DETAIL($id: ID!, $locale: String) {
    getDiscussionDetail(id: $id, locale: $locale) {
      ... on DiscussionDetail {
        ...discussionDetailsFragmentNew
      }
      ... on PermissionDenied {
        permissionType
        errorCode
        details
      }
    }
  }
`;

export const DISCUSSION_DETAIL_WITH_ROOMS = gql`
  ${roomFragment}
  query DISCUSSION_DETAIL($id: ID!, $locale: String) {
    getDiscussionDetail(id: $id, locale: $locale) {
      ... on DiscussionDetail {
        id
        timeFrames {
          id
          startDateTime
          endDateTime
        }
        rooms {
          ...roomFragment
        }
      }
      ... on PermissionDenied {
        permissionType
        errorCode
        details
      }
    }
  }
`;
